import {
  createBrowserRouter,
  createHashRouter,
  type RouteObject,
} from 'react-router-dom';
import { isNative } from './platform';

/**
 * Crea el router de la app eligiendo la estrategia según la plataforma:
 *
 * - **Web** → `createBrowserRouter` (History API, URLs limpias: comportamiento actual).
 * - **Nativo (Capacitor)** → `createHashRouter`. En el WebView la app se sirve desde
 *   `capacitor://` / `file://` y las rutas con History API rompen al recargar; el hash
 *   (`#/ruta`) funciona sin servidor y sin fallback SPA.
 *
 * Aísla la decisión en un solo sitio para que `src/router/index.tsx` solo delegue.
 */
export function createAppRouter(routes: RouteObject[]) {
  return isNative() ? createHashRouter(routes) : createBrowserRouter(routes);
}
